var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.email)?_c('a',{staticClass:"btn btn-outline-dark mr-2",attrs:{"href":'mail:'+_vm.email}},[_c('i',{staticClass:"fa fa-envelope"})]):_vm._e(),_vm._v(" "+_vm._s(_vm.email)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }